
export class ValidationError extends Error {
    message: string;
    validationErrors: Array<Object>
    userFriendlyMessage: string;

    constructor(message, validationErrors) {
        super(validationErrors)
        this.message = message
        this.validationErrors = validationErrors
        this.userFriendlyMessage = this.validationErrors ? Object.values(this.validationErrors).join("\n") : message;
        // the next line is important so that the ValidationError constructor is not part of the resulting stacktrace
        // this is NON standard (not in ECMA) function working only in V8/Chromium based browsers, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error 
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ValidationError)
        }
    }
}

export class UnexpectedError extends Error {
    message: string;
    userFriendlyMessage: string;
    constructor(message) {
        super(message)
        this.message = message
        this.userFriendlyMessage = message;
        // the next line is important so that the ValidationError constructor is not part of the resulting stacktrace
        // this is NON standard (not in ECMA) function working only in V8/Chromium based browsers, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error 
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ValidationError)
        }
    }
}